/* NORTAC GEAR · temaskript
   Handlekurv-skuff (Shopify AJAX Cart API), sticky nav, produktgalleri,
   varianter og mobil kjøpslinje. Alle skjemaer fungerer også uten JS
   (vanlig POST til /cart/add), så butikken tåler at skriptet feiler. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var demp = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function kr(ore) {
    return Math.round(ore / 100).toLocaleString('nb-NO') + ',-';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function bildeUrl(url, bredde) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(bredde));
      return u.toString();
    } catch (e) {
      return url;
    }
  }
  function json(url, valg) {
    valg = valg || {};
    valg.headers = Object.assign({ Accept: 'application/json' }, valg.headers || {});
    return fetch(url, valg).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var feil = new Error((data && (data.description || data.message)) || 'Noe gikk galt.');
          throw feil;
        }
        return data;
      });
    });
  }

  /* ── Sporing ──
     Sender egne hendelser (nt_*) via Shopify.analytics.publish. De leses av en egendefinert
     piksel under Innstillinger, Kundehendelser. Se innhold/LES-MEG.md. Ingen personopplysninger sendes. */
  function sporing(navn, data) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish('nt_' + navn, data || {});
    } catch (e) {}
  }
  function sted(el) {
    var seksjon = el && el.closest ? el.closest('[data-seksjon-navn], section, header, footer, aside') : null;
    if (!seksjon) return '';
    return seksjon.getAttribute('data-seksjon-navn') || seksjon.id || seksjon.className.toString().split(' ')[0] || seksjon.tagName.toLowerCase();
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-nt-hendelse]');
    if (h) {
      var data = {};
      try { data = JSON.parse(h.getAttribute('data-nt-data') || '{}'); } catch (x) {}
      data.sted = sted(h);
      sporing(h.getAttribute('data-nt-hendelse'), data);
      return;
    }
    var k = e.target.closest('a.nt-btn, button.nt-btn:not([type="submit"])');
    if (k) sporing('cta_klikk', { tekst: (k.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60), lenke: k.getAttribute('href') || '', sted: sted(k) });
  });
  // Produktvisning og søk (hvis sidene har data-attributter).
  (function () {
    var pv = document.querySelector('[data-nt-produktvisning]');
    if (pv) { try { sporing('produktvisning', JSON.parse(pv.getAttribute('data-nt-produktvisning'))); } catch (e) {} }
    var sok = document.querySelector('[data-nt-sok]');
    if (sok) sporing('sok', { sokeord: sok.getAttribute('data-nt-sok'), antall: Number(sok.getAttribute('data-nt-antall') || 0) });
  })();

  /* ── Sticky nav ── */
  var snav = document.querySelector('[data-snav]');
  if (snav) {
    var paaScroll = function () { snav.classList.toggle('er-scrollet', window.scrollY > 8); };
    paaScroll();
    window.addEventListener('scroll', paaScroll, { passive: true });
  }

  /* ── Handlekurv ── */
  var skuff = document.getElementById('nt-kurv-drawer');
  var overlay = document.getElementById('nt-kurv-overlay');
  var knapp = document.getElementById('nt-kurv-knapp');
  var lukk = document.getElementById('nt-kurv-lukk');
  var linjer = document.getElementById('nt-kurv-linjer');
  var tom = document.getElementById('nt-kurv-tom');
  var fot = document.getElementById('nt-kurv-footer');
  var sum = document.getElementById('nt-kurv-sum-verdi');
  var tall = document.getElementById('nt-kurv-tall');
  var feilEl = document.getElementById('nt-kurv-feil');
  var sisteFokus = null;

  function visFeil(tekst) {
    if (!feilEl) return;
    feilEl.textContent = tekst || '';
    feilEl.hidden = !tekst;
  }

  function oppdaterTall(antall) {
    if (!tall) return;
    tall.textContent = String(antall);
    tall.hidden = antall < 1;
  }

  // Speiler snippets/fraktlinje.liquid. Grensen gjelder ordresummen etter rabatter, som i kassen.
  function fraktHtml(kurv, el) {
    var grense = Number(el.getAttribute('data-fri-frakt-grense') || 0) * 100;
    var tid = esc(el.getAttribute('data-frakt-tid') || '');
    if (grense > 0) {
      var andel = Math.min(100, Math.floor(kurv.total_price * 100 / grense));
      var tekst = kurv.total_price >= grense
        ? '<strong>Du har fri frakt.</strong> Levering ' + tid + '.'
        : 'Handle for <strong>' + kr(grense - kurv.total_price) + '</strong> til, så får du fri frakt.';
      return '<span class="kv-frakt-tekst">' + tekst + '</span>' +
        '<span class="kv-frakt-bar' + (andel >= 100 ? ' er-full' : '') + '" aria-hidden="true"><i style="width: ' + andel + '%"></i></span>';
    }
    return '<span class="kv-frakt-tekst">' + esc(el.getAttribute('data-frakt-kort') || '') + ' kommer i tillegg. Levering ' + tid + '.</span>';
  }

  function tegn(kurv) {
    oppdaterTall(kurv.item_count);
    document.querySelectorAll('.kv-frakt[data-frakt-kort]').forEach(function (el) { el.innerHTML = fraktHtml(kurv, el); });
    if (!skuff) return;
    var harVarer = kurv.item_count > 0;
    if (tom) tom.hidden = harVarer;
    if (fot) fot.hidden = !harVarer;
    if (sum) sum.textContent = kr(kurv.total_price);
    tegnTilbehor(kurv);
    var rabattEl = document.getElementById('nt-kurv-rabatt');
    if (rabattEl) {
      var rab = kurv.cart_level_discount_applications || [];
      rabattEl.innerHTML = rab.length ? (
        '<div class="kv-rad"><span>Varer</span><span>' + kr(kurv.items_subtotal_price) + '</span></div>' +
        rab.map(function (r) {
          var navn = /^MEDLEM/i.test(r.title || '') ? 'Medlemsrabatt' : (/^VELKOMMEN/i.test(r.title || '') ? 'Velkomstrabatt' : 'Rabatt (' + esc(r.title || '') + ')');
          return '<div class="kv-rad kv-rad--rabatt"><span>' + navn + '</span><span>\u2212' + kr(r.total_allocated_amount) + '</span></div>';
        }).join('')
      ) : '';
    }
    if (!linjer) return;
    linjer.innerHTML = kurv.items.map(function (l) {
      var variant = l.variant_title && l.variant_title !== 'Default Title' ? '<span class="kv-linje-variant">' + esc(l.variant_title) + '</span>' : '';
      var egenskaper = l.properties ? Object.keys(l.properties).filter(function (n) { return n.charAt(0) !== '_' && l.properties[n]; }).map(function (n) { return '<span class="kv-linje-egenskap">' + esc(n) + ': ' + esc(l.properties[n]) + '</span>'; }).join('') : '';
      var bilde = l.image
        ? '<img src="' + esc(bildeUrl(l.image, 160)) + '" alt="" width="64" height="64" loading="lazy">'
        : '';
      return (
        '<div class="kv-linje" data-key="' + esc(l.key) + '">' +
          '<a class="kv-linje-bilde" href="' + esc(l.url) + '" tabindex="-1" aria-hidden="true">' + bilde + '</a>' +
          '<div class="kv-linje-info">' +
            '<a class="kv-linje-navn" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a>' +
            variant + egenskaper +
            '<span class="kv-linje-pris">' + kr(l.final_line_price) + '</span>' +
          '</div>' +
          '<div class="kv-steg">' +
            '<button type="button" class="kv-steg-btn" data-endre="-1" aria-label="Færre av ' + esc(l.product_title) + '">−</button>' +
            '<span class="kv-steg-tall" aria-label="Antall">' + l.quantity + '</span>' +
            '<button type="button" class="kv-steg-btn" data-endre="1" aria-label="Flere av ' + esc(l.product_title) + '">+</button>' +
          '</div>' +
          '<button type="button" class="kv-fjern" data-fjern>Fjern</button>' +
        '</div>'
      );
    }).join('');
  }

  /* Innlogget kunde med rabatt klar (gammel personlig medlemskode, eller velkomstkoden når e-posten er
     bekreftet og kunden ikke har handlet): sørg for at koden ligger i kurven når det er varer der. */
  var medlemskode = document.body.getAttribute('data-medlemskode');
  var kodeForsokt = false;
  function sikreRabatt(k) {
    if (!medlemskode || !k || !k.item_count || kodeForsokt) return k;
    var har = (k.discount_codes || []).some(function (x) { return (x.code || '').toUpperCase() === medlemskode.toUpperCase() && x.applicable !== false; });
    if (har) return k;
    kodeForsokt = true;
    return json(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: medlemskode }) })
      .catch(function () { return k; });
  }

  /* Tilbehør i skuffen: foreslå inntil to ting som passer det som ligger i kurven. */
  var tilbehorKart = null;
  try { var tkEl = document.getElementById('nt-tilbehor-kart'); if (tkEl) tilbehorKart = JSON.parse(tkEl.textContent); } catch (e) {}
  function tegnTilbehor(kurv) {
    var boks = document.getElementById('nt-kurv-tilbehor');
    if (!boks) return;
    var forslag = [], tittel = '';
    if (tilbehorKart && kurv.items.length) {
      var iKurv = kurv.items.map(function (l) { return l.product_id; });
      kurv.items.forEach(function (l) {
        var h = tilbehorKart.produkter[l.handle];
        if (!h) return;
        h.tilbehor.forEach(function (t) {
          if (forslag.length >= 2 || iKurv.indexOf(t.pid) > -1 || forslag.some(function (f) { return f.pid === t.pid; })) return;
          if (!tittel) tittel = h.tittel;
          forslag.push(t);
        });
      });
    }
    boks.hidden = !forslag.length;
    if (!forslag.length) { boks.innerHTML = ''; return; }
    boks.innerHTML = '<p class="kv-tilbehor-tittel">Passer til ' + esc(tittel) + '</p>' + forslag.map(function (t) {
      return '<div class="kv-tilbehor-rad">' +
        (t.bilde ? '<img src="' + esc(t.bilde) + '" alt="" width="48" height="48" loading="lazy">' : '<span></span>') +
        '<a class="kv-tilbehor-navn" href="' + esc(t.url) + '">' + esc(t.navn) + (t.variant ? '<small>' + esc(t.variant) + '</small>' : '') + (t.best ? '<small>Bestillingsvare</small>' : '') + '</a>' +
        '<span class="kv-tilbehor-pris">' + kr(t.pris) + '</span>' +
        '<button type="button" class="kv-tilbehor-knapp" data-legg-tilbehor="' + t.vid + '" data-best="' + (t.best ? '1' : '') + '" data-navn="' + esc(t.navn) + '">Legg til</button>' +
      '</div>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-legg-tilbehor]');
    if (!k) return;
    k.disabled = true; k.textContent = 'Legger til …';
    var linje = { id: Number(k.getAttribute('data-legg-tilbehor')), quantity: 1 };
    if (k.getAttribute('data-best') === '1' && tilbehorKart && (tilbehorKart.inn || tilbehorKart.lev)) linje.properties = { Bestillingsvare: tilbehorKart.inn ? 'Neste innbestilling ' + tilbehorKart.inn : 'Levering ' + tilbehorKart.lev };
    sporing('tilbehor_valgt', { tilbehor: k.getAttribute('data-navn') || '', sted: 'kurv' });
    json(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [linje] }) })
      .then(function () { return hentKurv(); })
      .catch(function (err) { visFeil(err.message); k.disabled = false; k.textContent = 'Legg til'; });
  });

  function hentKurv() {
    return json(ROOT + 'cart.js').then(sikreRabatt).then(function (k) { tegn(k); return k; });
  }
  window.ntKurv = { hent: function () { return hentKurv(); } };

  function apne() {
    if (!skuff) { window.location.href = ROOT + 'cart'; return; }
    sisteFokus = document.activeElement;
    skuff.classList.add('er-apen');
    document.documentElement.classList.add('nt-kurv-apen');
    skuff.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    if (knapp) knapp.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (lukk) lukk.focus(); }, 60);
  }
  function lukkSkuff() {
    if (!skuff) return;
    skuff.classList.remove('er-apen');
    document.documentElement.classList.remove('nt-kurv-apen');
    skuff.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    if (knapp) knapp.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    if (sisteFokus && sisteFokus.focus) sisteFokus.focus();
  }

  if (knapp) knapp.addEventListener('click', function (e) { e.preventDefault(); visFeil(''); hentKurv().catch(function () {}); apne(); });

  /* Gå til kassen: vis at noe skjer (trege nettlesere i apper), og oppdater kurven når man kommer tilbake. */
  document.addEventListener('submit', function (e) {
    var kasse = e.target.closest('form[data-kasse]');
    if (!kasse) return;
    var b = kasse.querySelector('[name="checkout"]');
    if (!b) return;
    if (b.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    b.setAttribute('aria-busy', 'true'); b.textContent = 'Åpner kassen …';
    sporing('til_kassen', {});
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('form[data-kasse] [name="checkout"]').forEach(function (b) { b.removeAttribute('aria-busy'); b.textContent = 'Gå til kassen'; });
    if (skuff) hentKurv().catch(function () {});
  });
  if (lukk) lukk.addEventListener('click', lukkSkuff);
  if (overlay) overlay.addEventListener('click', lukkSkuff);
  document.addEventListener('keydown', function (e) {
    if (document.querySelector('dialog[open]')) return;
    if (e.key === 'Escape' && skuff && skuff.classList.contains('er-apen')) lukkSkuff();
  });

  if (linjer) {
    linjer.addEventListener('click', function (e) {
      var maal = e.target.closest('[data-endre], [data-fjern]');
      if (!maal) return;
      var rad = maal.closest('[data-key]');
      if (!rad) return;
      var naa = parseInt(rad.querySelector('.kv-steg-tall').textContent, 10) || 0;
      var nytt = maal.hasAttribute('data-fjern') ? 0 : Math.max(0, naa + parseInt(maal.getAttribute('data-endre'), 10));
      skuff.classList.add('er-opptatt');
      visFeil('');
      json(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rad.getAttribute('data-key'), quantity: nytt })
      })
        .then(tegn)
        .catch(function (err) { visFeil(err.message); hentKurv().catch(function () {}); })
        .then(function () { skuff.classList.remove('er-opptatt'); });
    });
  }

  // Legg i kurv: alle skjemaer med data-legg-i-kurv sendes via AJAX.
  document.addEventListener('submit', function (e) {
    var skjema = e.target.closest('form[data-legg-i-kurv]');
    if (!skjema || !window.fetch || !skuff) return;
    e.preventDefault();
    if (skjema.hasAttribute('data-opptatt')) return;
    skjema.setAttribute('data-opptatt', '');
    var btn = skjema.querySelector('[type="submit"]');
    var opprinnelig = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = 'Legger i kurv …'; }
    var sk = skjema.id ? document.querySelector('[data-send-skjema="' + skjema.id + '"]') : null;
    var skTekst = sk ? sk.textContent : '';
    if (sk) { sk.disabled = true; sk.setAttribute('aria-busy', 'true'); sk.textContent = 'Legger i kurv …'; }
    visFeil('');
    var fd = new FormData(skjema);
    /* Avkrysset tilbehør i kjøpsboksen legges i kurven sammen med hovedproduktet. */
    var boks = skjema.querySelector('[data-tilbehor-boks]');
    var valgte = boks ? [].slice.call(boks.querySelectorAll('[data-tilbehor]:checked')) : [];
    var kropp = fd;
    if (valgte.length) {
      var egenskaper = {};
      fd.forEach(function (verdi, navn) { var m = /^properties\[(.+)\]$/.exec(navn); if (m) egenskaper[m[1]] = verdi; });
      var innDato = boks.getAttribute('data-inn-dato');
      var levTid = boks.getAttribute('data-lev');
      var varer = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: egenskaper }];
      valgte.forEach(function (c) {
        var vEl = c.closest('[data-tilbehor-rad]').querySelector('[data-tilbehor-variant]');
        var valgt = vEl.tagName === 'SELECT' ? vEl.options[vEl.selectedIndex] : vEl;
        var linje = { id: Number(vEl.value), quantity: 1 };
        if (valgt && valgt.getAttribute('data-bestilling') === '1' && (innDato || levTid)) linje.properties = { Bestillingsvare: innDato ? 'Neste innbestilling ' + innDato : 'Levering ' + levTid };
        varer.push(linje);
        sporing('tilbehor_valgt', { tilbehor: c.getAttribute('data-produkt') || '', sted: 'kjopsboks' });
      });
      kropp = JSON.stringify({ items: varer });
    }
    json(ROOT + 'cart/add.js', kropp === fd ? { method: 'POST', body: fd } : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: kropp })
      .then(function (svar) {
        var linje = svar && svar.items ? svar.items[0] : svar;
        if (valgte.length) valgte.forEach(function (c) { c.checked = false; });
        sporing('legg_i_kurv', { produkt: linje.product_title, variant: linje.variant_title || '', pris: linje.final_price, antall: linje.quantity, forhandsbestilling: !!(linje.properties && linje.properties['Forhåndsbestilling']), sted: sted(skjema) });
        return hentKurv();
      })
      .then(function () { apne(); })
      .catch(function (err) { sporing('kurv_feil', { melding: String(err && err.message || '').slice(0, 80) }); hentKurv().catch(function () {}); apne(); visFeil(err.message); })
      .then(function () {
        skjema.removeAttribute('data-opptatt');
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = opprinnelig; }
        if (sk) { sk.removeAttribute('aria-busy'); sk.textContent = skTekst; sk.disabled = false; }
      });
  });

  /* Tilbehør i kjøpsboksen: valgt variant viser sin pris, og den som velger variant vil ha tilbehøret. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-tilbehor-variant]');
    if (!sel) return;
    var rad = sel.closest('[data-tilbehor-rad]');
    if (!rad) return;
    var opt = sel.options[sel.selectedIndex];
    var prisEl = rad.querySelector('[data-tilbehor-pris]');
    if (prisEl && opt && opt.getAttribute('data-pris')) prisEl.textContent = '+' + kr(Number(opt.getAttribute('data-pris')));
    var sjekk = rad.querySelector('[data-tilbehor]');
    if (sjekk) sjekk.checked = true;
  });

  // Mobil kjøpslinje: send hovedskjemaet på produktsiden.
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-send-skjema]');
    if (!k) return;
    var skjema = document.getElementById(k.getAttribute('data-send-skjema'));
    if (skjema && skjema.requestSubmit) skjema.requestSubmit();
    else if (skjema) skjema.submit();
  });

  /* ── Produktgalleri ── */
  var hoved = document.querySelector('[data-galleri-hoved] img');
  var hovedBoks = document.querySelector('[data-galleri-hoved]');
  var teller = document.querySelector('[data-galleri-teller]');
  var synligeMinier = function () {
    return [].slice.call(document.querySelectorAll('[data-galleri-mini]')).filter(function (k) { return !k.hidden; });
  };
  var oppdaterTeller = function () {
    if (!teller) return;
    var liste = synligeMinier();
    var i = liste.findIndex(function (k) { return k.classList.contains('er-valgt'); });
    teller.textContent = liste.length > 1 ? (Math.max(i, 0) + 1) + ' / ' + liste.length : '';
    document.querySelectorAll('[data-galleri-forrige], [data-galleri-neste]').forEach(function (b) { b.hidden = liste.length < 2; });
  };
  var hovedVideo = document.querySelector('[data-galleri-video-el]');
  var velgMini = function (mini) {
    if (!mini) return;
    var videoKilde = mini.getAttribute('data-galleri-video');
    if (videoKilde && hovedVideo) {
      // Video: vis videospilleren i hovedruten og skjul bildet.
      if (hovedVideo.getAttribute('src') !== videoKilde) {
        hovedVideo.setAttribute('poster', mini.getAttribute('data-galleri-mini') || '');
        hovedVideo.src = videoKilde;
      }
      hovedVideo.classList.remove('er-skjult');
      if (hoved) hoved.classList.add('er-skjult');
      var spill = hovedVideo.play();
      if (spill && spill.catch) spill.catch(function () {});
    } else {
      if (hovedVideo) { hovedVideo.pause(); hovedVideo.classList.add('er-skjult'); }
      if (hoved) {
        hoved.classList.remove('er-skjult');
        hoved.src = mini.getAttribute('data-galleri-mini');
        hoved.removeAttribute('srcset');
        var alt = mini.getAttribute('data-alt');
        if (alt != null) hoved.alt = alt;
      }
    }
    document.querySelectorAll('[data-galleri-mini]').forEach(function (k) {
      k.classList.toggle('er-valgt', k === mini);
      k.setAttribute('aria-pressed', String(k === mini));
    });
    var naboer = synligeMinier(), ix = naboer.indexOf(mini);
    [naboer[ix + 1], naboer[ix - 1]].forEach(function (k) { if (k) { var forh = new Image(); forh.src = k.getAttribute('data-galleri-mini'); } });
    var rad = mini.parentElement;
    if (rad && rad.scrollWidth > rad.clientWidth) {
      rad.scrollTo({ left: mini.offsetLeft - rad.clientWidth / 2 + mini.clientWidth / 2, behavior: 'smooth' });
    }
    oppdaterTeller();
  };
  var stegGalleri = function (retning) {
    var liste = synligeMinier();
    if (liste.length < 2) return;
    var i = liste.findIndex(function (k) { return k.classList.contains('er-valgt'); });
    velgMini(liste[(i + retning + liste.length) % liste.length]);
  };
  document.querySelectorAll('[data-galleri-mini]').forEach(function (mini) {
    mini.addEventListener('click', function () { velgMini(mini); });
  });
  var forrigeKnapp = document.querySelector('[data-galleri-forrige]');
  var nesteKnapp = document.querySelector('[data-galleri-neste]');
  if (forrigeKnapp) forrigeKnapp.addEventListener('click', function () { stegGalleri(-1); });
  if (nesteKnapp) nesteKnapp.addEventListener('click', function () { stegGalleri(1); });
  if (hovedBoks && synligeMinier().length > 1) {
    var gx0 = null, gy0 = null;
    hovedBoks.addEventListener('touchstart', function (e) { gx0 = e.touches[0].clientX; gy0 = e.touches[0].clientY; }, { passive: true });
    hovedBoks.addEventListener('touchend', function (e) {
      if (gx0 === null) return;
      var dx = e.changedTouches[0].clientX - gx0, dy = e.changedTouches[0].clientY - gy0; gx0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stegGalleri(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  oppdaterTeller();

  /* ── Varianter ── */
  var variantData = document.getElementById('nt-varianter-data');
  var opsjoner = document.querySelector('[data-opsjoner]');
  if (variantData && opsjoner) {
    var varianter = [];
    try { varianter = JSON.parse(variantData.textContent); } catch (e) {}
    var bildefilter = {};
    var filterEl = document.getElementById('nt-bildefilter');
    if (filterEl) { try { bildefilter = JSON.parse(filterEl.textContent) || {}; } catch (e) {} }
    // Viser bare bildene som passer valgt farge, blad osv. Bilder uten merking vises alltid.
    var filtrerBilder = function () {
      var navnVerdi = {};
      opsjoner.querySelectorAll('input[data-opsjon-navn]:checked').forEach(function (r) {
        navnVerdi[r.getAttribute('data-opsjon-navn')] = r.value;
      });
      var forste = null, valgtSynlig = false;
      document.querySelectorAll('[data-galleri-mini][data-media-id]').forEach(function (k) {
        var t = bildefilter[k.getAttribute('data-media-id')] || {};
        var vis = Object.keys(t).every(function (n) { return !(n in navnVerdi) || navnVerdi[n] === t[n]; });
        k.hidden = !vis;
        if (vis && !forste) forste = k;
        if (vis && k.classList.contains('er-valgt')) valgtSynlig = true;
      });
      var rad = document.querySelector('.pd-miniatyrer');
      if (rad) rad.scrollLeft = 0;
      oppdaterTeller();
      return { forste: forste, valgtSynlig: valgtSynlig };
    };
    var visMini = velgMini;
    if (Object.keys(bildefilter).length) {
      var start = filtrerBilder();
      if (!start.valgtSynlig) visMini(start.forste);
    }
    opsjoner.addEventListener('change', function (e) {
      var valgt = [];
      opsjoner.querySelectorAll('input[data-opsjon-indeks]:checked').forEach(function (r) {
        valgt[Number(r.getAttribute('data-opsjon-indeks'))] = r.value;
      });
      var filt = Object.keys(bildefilter).length ? filtrerBilder() : null;
      var v = varianter.find(function (x) {
        return x.opsjoner.every(function (o, i) { return o === valgt[i]; });
      });
      var legg = document.querySelector('[data-legg-knapp]');
      if (!v) {
        if (legg) { legg.disabled = true; legg.textContent = 'Ikke tilgjengelig'; }
        var skIngen = document.querySelector('[data-sticky-knapp]');
        if (skIngen) skIngen.disabled = true;
        return;
      }
      var idFelt = document.querySelector('[data-variant-id]');
      if (idFelt) idFelt.value = v.id;
      if (e && e.isTrusted) sporing('produktvalg', { variant: v.opsjoner.join(' / '), pris: v.pris });
      document.querySelectorAll('[data-variant-pris]').forEach(function (el) { el.textContent = kr(v.pris); });
      document.querySelectorAll('[data-variant-pris-medlem]').forEach(function (el) {
        var prosent = Number(el.getAttribute('data-prosent') || 10);
        var mp = Math.floor(v.pris * (100 - prosent) / 100), ore = mp % 100;
        el.textContent = ore ? Math.floor(mp / 100).toLocaleString('nb-NO') + ',' + String(ore).padStart(2, '0') + ' kr' : kr(mp);
      });
      var kommer = legg && legg.hasAttribute('data-kommer');
      var forhand = legg && legg.hasAttribute('data-forhand');
      var tekst = kommer ? 'Kommer snart' : (forhand ? (v.tilgjengelig ? 'Forhåndsbestill' : 'Kommer snart') : (!v.tilgjengelig ? 'Utsolgt' : (v.bestilling ? 'Bestill nå' : 'Legg i handlekurv')));
      if (legg) { legg.disabled = kommer || !v.tilgjengelig; legg.textContent = tekst; }
      var sk = document.querySelector('[data-sticky-knapp]');
      if (sk) {
        if (!sk.hasAttribute('data-rull')) sk.textContent = forhand ? (v.tilgjengelig ? 'Forhåndsbestill' : 'Kommer snart') : (!v.tilgjengelig ? 'Utsolgt' : (v.bestilling ? 'Bestill' : 'Legg i kurv'));
        sk.disabled = !v.tilgjengelig;
      }
      var fInfo = document.querySelector('.pd-forhand');
      if (fInfo) fInfo.hidden = !v.tilgjengelig;
      var status = document.querySelector('[data-variant-status]');
      if (status) status.innerHTML = v.status;
      var lev = document.querySelector('[data-variant-lev]');
      if (lev) {
        if (v.bestilling && !lev.innerHTML.trim()) lev.innerHTML = lev.getAttribute('data-tekst') || '';
        lev.hidden = !v.bestilling;
      }
      var bestEgenskap = document.querySelector('[data-bestilling-egenskap]');
      if (bestEgenskap) bestEgenskap.disabled = !v.bestilling;
      var ford = document.querySelector('.pd-fordeler');
      var fraktTekst = ford && ford.querySelector('li span');
      if (fraktTekst) fraktTekst.textContent = ford.getAttribute(v.bestilling ? 'data-frakt-bestilling' : 'data-frakt-lager');
      var base = v.bilde ? v.bilde.split('?')[0] : null;
      var treff = null;
      if (base) {
        document.querySelectorAll('[data-galleri-mini]').forEach(function (k) {
          if (!k.hidden && k.getAttribute('data-galleri-mini').split('?')[0] === base) treff = k;
        });
      }
      if (treff) visMini(treff);
      else if (filt && filt.forste) visMini(filt.forste);
      else if (v.bilde && hoved) { hoved.src = v.bilde; hoved.removeAttribute('srcset'); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ── Bladguide: velg blad fra kortene ── */
  var bladKnapper = [].slice.call(document.querySelectorAll('[data-velg-opsjon]'));
  var markerBlad = function () {
    bladKnapper.forEach(function (b) {
      var r = document.querySelector('input[data-opsjon-navn="' + b.getAttribute('data-velg-opsjon') + '"]:checked');
      var valgt = r && r.value === b.getAttribute('data-velg-verdi');
      b.closest('.pd-blad-kort').classList.toggle('er-valgt', !!valgt);
      b.textContent = valgt ? 'Valgt' : b.getAttribute('data-tekst') || b.textContent;
    });
  };
  bladKnapper.forEach(function (b) {
    b.setAttribute('data-tekst', b.textContent);
    b.addEventListener('click', function () {
      var navn = b.getAttribute('data-velg-opsjon'), verdi = b.getAttribute('data-velg-verdi');
      var r = [].slice.call(document.querySelectorAll('input[data-opsjon-navn]')).find(function (i) {
        return i.getAttribute('data-opsjon-navn') === navn && i.value === verdi;
      });
      if (!r) return;
      r.checked = true;
      sporing('blad_valgt', { valg: verdi });
      r.dispatchEvent(new Event('change', { bubbles: true }));
      var kjopBoks = document.getElementById('pd-kjop');
      if (kjopBoks) kjopBoks.scrollIntoView({ behavior: demp ? 'auto' : 'smooth', block: 'center' });
    });
  });
  if (bladKnapper.length) {
    var ops = document.querySelector('[data-opsjoner]');
    if (ops) ops.addEventListener('change', markerBlad);
    markerBlad();
  }

  /* ── Mobil kjøpslinje på produktsiden ──
     Vises hele tiden kjøpsknappen er utenfor skjermen, både før man har scrollet ned til den og etter.
     Har produktet valg (farge, blad) og kunden ikke har sett kjøpsboksen ennå, ruller knappen dit i stedet for å legge i kurv. */
  var sticky = document.querySelector('[data-pd-sticky]');
  var kjop = document.getElementById('pd-kjop');
  var hovedKnapp = document.querySelector('[data-legg-knapp]');
  if (sticky && kjop && hovedKnapp && 'IntersectionObserver' in window) {
    var stickyKnapp = sticky.querySelector('button');
    /* Bare reelle valg teller: grupper med minst to kjøpbare verdier. */
    var harValg = [].some.call(document.querySelectorAll('[data-opsjoner] .pd-opsjon'), function (f) {
      return f.querySelectorAll('input:not([disabled])').length > 1;
    });
    var settBoks = false;
    var stickyTekst = stickyKnapp ? stickyKnapp.textContent : '';
    var oppdaterModus = function () {
      if (!stickyKnapp) return;
      var rull = harValg && !settBoks;
      stickyKnapp.toggleAttribute('data-rull', rull);
      if (rull) stickyKnapp.textContent = 'Velg og kjøp';
      else if (stickyKnapp.textContent === 'Velg og kjøp') stickyKnapp.textContent = stickyTekst;
    };
    if (stickyKnapp) {
      stickyKnapp.addEventListener('click', function (e) {
        if (!stickyKnapp.hasAttribute('data-rull')) return;
        e.preventDefault(); e.stopPropagation();
        var maal = document.querySelector('[data-opsjoner] fieldset') || hovedKnapp;
        maal.scrollIntoView({ behavior: demp ? 'auto' : 'smooth', block: 'center' });
        sporing('kjopslinje_klikk', { modus: 'rull' });
      });
    }
    new IntersectionObserver(function (poster) {
      if (poster[0].isIntersecting && !settBoks) { settBoks = true; oppdaterModus(); }
    }, { threshold: 0.3 }).observe(kjop);
    new IntersectionObserver(function (poster) {
      var vis = !poster[0].isIntersecting;
      sticky.classList.toggle('er-synlig', vis);
      sticky.setAttribute('aria-hidden', String(!vis));
      document.body.classList.toggle('har-kjopslinje', vis && window.matchMedia('(max-width: 860px)').matches);
      if (stickyKnapp) stickyKnapp.setAttribute('tabindex', vis ? '0' : '-1');
    }).observe(hovedKnapp);
    oppdaterModus();
  }

  /* ── Skriv ut (angrerettskjema) ── */
  document.querySelectorAll('[data-skriv-ut]').forEach(function (b) {
    b.addEventListener('click', function () { window.print(); });
  });
})();


/* ── Bevegelse: innrulling, bildefade og lett parallakse ── */
(function () {
  'use strict';
  var demp = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Bilder: marker som lastet når de er ferdige (fade-in i CSS) */
  document.querySelectorAll('.pk-bilde img, .spot-bilde img, .butikken-bilde img, .bl-bilde img, .ar-bilde img').forEach(function (img) {
    var ferdig = function () { img.classList.add('er-lastet'); };
    if (img.complete) ferdig();
    else { img.addEventListener('load', ferdig, { once: true }); img.addEventListener('error', ferdig, { once: true }); }
  });

  /* Innrulling: bare elementer under folden skjules og vises når de kommer til syne */
  if (!demp && 'IntersectionObserver' in window) {
    var velger = [
      '.utvalg-topp', '.insp-topp', '.insp-rute', '.nyhet-inn', '.utvalg .nt-grid > *', '.butikken-tekst', '.butikken-bilde',
      '.ferden-band-inn', '.nb', '.sfoot-grid', '.kt-topp', '.kt-kommer', '.nt-grid > .pk', '.bl-kort',
      '.pd-seksjon', '.pd-detalj', '.side-inn > *', '.ar-tekst'
    ].join(',');
    var vinduH = window.innerHeight || document.documentElement.clientHeight;
    var maal = [];
    document.querySelectorAll(velger).forEach(function (el, i) {
      if (el.getBoundingClientRect().top < vinduH * 0.92) return;
      var naboer = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--nt-d', Math.min(naboer, 5) * 0.08 + 's');
      el.classList.add('nt-skjult');
      maal.push(el);
    });
    var obs = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        var el = p.target;
        el.classList.add('er-inn');
        obs.unobserve(el);
        /* Rydd bort innrullingsklassene etterpå, så hover ikke arver forsinkelsen */
        setTimeout(function () { el.classList.remove('nt-skjult', 'er-inn'); el.style.removeProperty('--nt-d'); }, 1500);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    maal.forEach(function (el) { obs.observe(el); });
    /* Sikkerhetsnett: vis alt om noe likevel ikke er vist etter noen sekunder */
    setTimeout(function () { maal.forEach(function (el) { el.classList.add('er-inn'); }); }, 6000);
  }

  /* Hero-karusell: lysbilder med piler, prikker og sveip, bytter hvert 5. sekund */
  var heroK = document.querySelector('[data-hero]');
  if (heroK) {
    var slides = [].slice.call(heroK.querySelectorAll('[data-slide]'));
    var prikker = [].slice.call(heroK.querySelectorAll('[data-prikk]'));
    var kontroll = heroK.querySelector('[data-kontroll]');
    var idx = 0, timer = null, brukerStoppet = demp, over = false;
    var vis = function (n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (sl, i) {
        var aktiv = i === idx;
        sl.classList.toggle('er-aktiv', aktiv);
        if (aktiv) { sl.removeAttribute('aria-hidden'); sl.removeAttribute('inert'); }
        else { sl.setAttribute('aria-hidden', 'true'); sl.setAttribute('inert', ''); }
      });
      prikker.forEach(function (p, i) {
        p.classList.toggle('er-aktiv', i === idx);
        if (i === idx) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
    };
    var stopp = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () {
      stopp();
      if (brukerStoppet || over || document.hidden || slides.length < 2) return;
      timer = setInterval(function () { vis(idx + 1); }, 5000);
    };
    var gaa = function (n) { vis(n); start(); };
    if (kontroll && slides.length > 1) {
      kontroll.hidden = false;
      slides.forEach(function (sl, i) { if (i) sl.setAttribute('inert', ''); });
      heroK.querySelector('[data-forrige]').addEventListener('click', function () { gaa(idx - 1); });
      heroK.querySelector('[data-neste]').addEventListener('click', function () { gaa(idx + 1); });
      prikker.forEach(function (p) { p.addEventListener('click', function () { gaa(parseInt(p.getAttribute('data-prikk'), 10)); }); });
      heroK.addEventListener('focusin', function () { over = true; stopp(); });
      heroK.addEventListener('focusout', function () { over = false; start(); });
      heroK.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { gaa(idx - 1); } else if (e.key === 'ArrowRight') { gaa(idx + 1); }
      });
      var x0 = null;
      heroK.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      heroK.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) gaa(idx + (dx < 0 ? 1 : -1));
      }, { passive: true });
      document.addEventListener('visibilitychange', start);
      start();
    }
  }

  /* Parallakse på heroen: lite, bare på større skjermer */
  var hero = heroK || document.querySelector('.hero');
  if (hero && !demp && window.innerWidth > 800) {
    var ventende = false;
    var oppdater = function () {
      ventende = false;
      var y = window.scrollY;
      if (y > hero.offsetHeight) return;
      hero.style.setProperty('--nt-px', Math.min(44, Math.round(y * 0.08)) + 'px');
    };
    window.addEventListener('scroll', function () {
      if (!ventende) { ventende = true; window.requestAnimationFrame(oppdater); }
    }, { passive: true });
  }
})();

/* ── Produktoversikt: merkevalg, filtre og sortering ── */
(function () {
  var rot = document.querySelector('[data-kt]');
  if (!rot) return;
  var skjema = rot.querySelector('[data-filter-skjema]');
  var panel = rot.querySelector('[data-filter-panel]');
  var rutenett = rot.querySelector('[data-varer]');
  if (!skjema || !rutenett) return;

  var varer = Array.prototype.slice.call(rutenett.querySelectorAll('[data-vare]'));
  var skygge = rot.querySelector('.kt-skygge');
  var apneKnapp = rot.querySelector('[data-filter-apne]');
  var sortering = rot.querySelector('[data-sortering]');
  var aktiveListe = rot.querySelector('[data-aktive-filtre]');
  var ingenTreff = rot.querySelector('[data-ingen-treff]');
  var prisGruppe = rot.querySelector('.kt-gruppe--pris');
  var prisMin = skjema.querySelector('[name="pris_min"]');
  var prisMaks = skjema.querySelector('[name="pris_maks"]');
  var prisLav = prisGruppe ? Number(prisGruppe.getAttribute('data-pris-lav')) : 0;
  var prisHoy = prisMaks ? Number(prisMaks.value) : 0;
  if (prisMin) prisLav = Number(prisMin.value);
  var grupper = ['merke', 'kategori', 'vekt', 'lager'];
  var navn = { u500: 'Under 500 g', '500-1000': '500 g til 1 kg', o1000: 'Over 1 kg', lager: 'På lager i Norge', bestilling: 'Bestillingsvare', kommer: 'Kommer snart', forhand: 'Forhåndsbestilling' };

  var data = varer.map(function (el) {
    var vekt = el.getAttribute('data-vekt');
    return {
      el: el,
      indeks: Number(el.getAttribute('data-indeks')),
      merke: el.getAttribute('data-merke') || '',
      kategori: el.getAttribute('data-kategori') || '',
      prisMin: Number(el.getAttribute('data-pris-min')),
      prisMaks: Number(el.getAttribute('data-pris-maks')),
      vekt: vekt ? Number(vekt) : null,
      lager: el.getAttribute('data-lager'),
      navn: el.getAttribute('data-navn') || ''
    };
  });

  function vektKlasse(g) {
    if (g == null || isNaN(g)) return null;
    if (g < 500) return 'u500';
    if (g <= 1000) return '500-1000';
    return 'o1000';
  }

  function valgte(gruppe) {
    return Array.prototype.slice.call(skjema.querySelectorAll('[name="' + gruppe + '"]:checked')).map(function (i) { return i.value; });
  }

  function tilstand() {
    var t = {};
    grupper.forEach(function (g) { t[g] = valgte(g); });
    t.prisMin = prisMin ? Number(prisMin.value) : null;
    t.prisMaks = prisMaks ? Number(prisMaks.value) : null;
    return t;
  }

  function passer(d, t, unntak) {
    if (unntak !== 'merke' && t.merke.length && t.merke.indexOf(d.merke) < 0) return false;
    if (unntak !== 'kategori' && t.kategori.length && t.kategori.indexOf(d.kategori) < 0) return false;
    if (unntak !== 'vekt' && t.vekt.length && t.vekt.indexOf(vektKlasse(d.vekt)) < 0) return false;
    if (unntak !== 'lager' && t.lager.length && t.lager.indexOf(d.lager) < 0) return false;
    if (prisMin && (d.prisMaks < t.prisMin || d.prisMin > t.prisMaks)) return false;
    return true;
  }

  function verdiFor(d, gruppe) {
    if (gruppe === 'vekt') return vektKlasse(d.vekt);
    return d[gruppe];
  }

  function oppdaterAntall(t) {
    grupper.forEach(function (g) {
      var teller = {};
      data.forEach(function (d) {
        if (!passer(d, t, g)) return;
        var v = verdiFor(d, g);
        if (v != null) teller[v] = (teller[v] || 0) + 1;
      });
      skjema.querySelectorAll('[name="' + g + '"]').forEach(function (inp) {
        var n = teller[inp.value] || 0;
        var lapp = inp.parentNode.querySelector('.kt-valg-antall');
        if (lapp) lapp.textContent = n;
        inp.parentNode.classList.toggle('er-tom', n === 0 && !inp.checked);
      });
    });
    skjema.querySelectorAll('[name="lager"]').forEach(function (inp) {
      inp.parentNode.hidden = !data.some(function (d) { return d.lager === inp.value; });
    });
    var vektGruppe = skjema.querySelector('[data-gruppe-vekt]');
    if (vektGruppe) vektGruppe.hidden = !data.some(function (d) { return d.vekt != null; });
  }

  function sorter() {
    var s = sortering ? sortering.value : '';
    var liste = data.slice();
    liste.sort(function (a, b) {
      if (s === 'pris-lav') return a.prisMin - b.prisMin || a.indeks - b.indeks;
      if (s === 'pris-hoy') return b.prisMaks - a.prisMaks || a.indeks - b.indeks;
      if (s === 'vekt') {
        var av = a.vekt == null ? Infinity : a.vekt, bv = b.vekt == null ? Infinity : b.vekt;
        return av - bv || a.indeks - b.indeks;
      }
      if (s === 'navn') return a.navn.localeCompare(b.navn, 'nb');
      /* Utvalgt: det som er på lager først, så forhåndsbestilling, bestillingsvarer og til slutt det som kommer. */
      var rang = { lager: 0, forhand: 1, bestilling: 2, utsolgt: 3, kommer: 4 };
      return ((rang[a.lager] || 0) - (rang[b.lager] || 0)) || a.indeks - b.indeks;
    });
    liste.forEach(function (d) { rutenett.appendChild(d.el); });
  }

  function kr(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }

  function oppdaterPris() {
    if (!prisMin) return;
    var a = Number(prisMin.value), b = Number(prisMaks.value);
    if (a > b) { var tmp = a; a = b; b = tmp; }
    rot.querySelector('[data-pris-fra]').textContent = kr(a);
    rot.querySelector('[data-pris-til]').textContent = kr(b);
    var spenn = prisHoy - prisLav || 1;
    var fyll = rot.querySelector('[data-pris-fyll]');
    fyll.style.left = ((a - prisLav) / spenn * 100) + '%';
    fyll.style.right = (100 - (b - prisLav) / spenn * 100) + '%';
  }

  function lagBrikke(tekst, ved) {
    var li = document.createElement('li');
    var k = document.createElement('button');
    k.type = 'button';
    k.className = 'kt-brikke';
    k.setAttribute('aria-label', 'Fjern filter ' + tekst);
    k.innerHTML = '<span></span><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" fill="none" stroke-linecap="round"/></svg>';
    k.firstChild.textContent = tekst;
    k.addEventListener('click', ved);
    li.appendChild(k);
    return li;
  }

  function oppdaterAktive(t) {
    aktiveListe.innerHTML = '';
    var antall = 0;
    grupper.forEach(function (g) {
      t[g].forEach(function (v) {
        antall++;
        aktiveListe.appendChild(lagBrikke(navn[v] || v, function () {
          var inp = skjema.querySelector('[name="' + g + '"][value="' + CSS.escape(v) + '"]');
          if (inp) inp.checked = false;
          bruk();
        }));
      });
    });
    var prisAktiv = prisMin && (Number(prisMin.value) > prisLav || Number(prisMaks.value) < prisHoy);
    if (prisAktiv) {
      antall++;
      aktiveListe.appendChild(lagBrikke(kr(Math.min(t.prisMin, t.prisMaks)) + ' til ' + kr(Math.max(t.prisMin, t.prisMaks)) + ' kr', function () {
        prisMin.value = prisLav; prisMaks.value = prisHoy; bruk();
      }));
    }
    if (antall > 1) {
      var li = document.createElement('li');
      var n = document.createElement('button');
      n.type = 'button'; n.className = 'kt-brikke kt-brikke--nullstill'; n.textContent = 'Nullstill alle';
      n.addEventListener('click', nullstill);
      li.appendChild(n); aktiveListe.appendChild(li);
    }
    aktiveListe.hidden = antall === 0;
    var merke = rot.querySelector('[data-antall-aktive]');
    if (merke) { merke.textContent = antall; merke.hidden = antall === 0; }
  }

  function oppdaterMerkekort(t) {
    rot.querySelectorAll('[data-merke-kort]').forEach(function (a) {
      var m = a.getAttribute('data-merke-kort');
      var valgt = m === '' ? t.merke.length === 0 : (t.merke.length === 1 && t.merke[0] === m);
      a.classList.toggle('er-valgt', valgt);
      if (valgt) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }

  function skrivAdresse(t) {
    var p = new URLSearchParams(window.location.search);
    grupper.forEach(function (g) { if (t[g].length) p.set(g, t[g].join(',')); else p.delete(g); });
    if (prisMin && (t.prisMin > prisLav || t.prisMaks < prisHoy)) p.set('pris', Math.min(t.prisMin, t.prisMaks) + '-' + Math.max(t.prisMin, t.prisMaks)); else p.delete('pris');
    if (sortering && sortering.value) p.set('sorter', sortering.value); else p.delete('sorter');
    p.delete('sort_by');
    var q = p.toString();
    history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
  }

  function lesAdresse() {
    var p = new URLSearchParams(window.location.search);
    grupper.forEach(function (g) {
      var v = p.get(g);
      if (!v) return;
      v.split(',').forEach(function (verdi) {
        var inp = skjema.querySelector('[name="' + g + '"][value="' + CSS.escape(verdi) + '"]');
        if (inp) inp.checked = true;
      });
    });
    var pris = p.get('pris');
    if (pris && prisMin) {
      var deler = pris.split('-').map(Number);
      if (!isNaN(deler[0])) prisMin.value = deler[0];
      if (!isNaN(deler[1])) prisMaks.value = deler[1];
    }
    var s = p.get('sorter');
    if (s && sortering) sortering.value = s;
  }

  function bruk() {
    var t = tilstand();
    if (prisMin && t.prisMin > t.prisMaks) { var x = t.prisMin; t.prisMin = t.prisMaks; t.prisMaks = x; }
    var treff = 0;
    data.forEach(function (d) {
      var ok = passer(d, t);
      d.el.hidden = !ok;
      if (ok) treff++;
    });
    rot.querySelectorAll('[data-antall-treff]').forEach(function (s) { s.textContent = treff; });
    rot.querySelectorAll('[data-antall-ord]').forEach(function (s) { s.textContent = treff === 1 ? 'vare' : 'varer'; });
    if (ingenTreff) ingenTreff.hidden = treff > 0;
    rutenett.hidden = treff === 0;
    oppdaterPris();
    oppdaterAntall(t);
    oppdaterAktive(t);
    oppdaterMerkekort(t);
    skrivAdresse(t);
  }

  function nullstill() {
    skjema.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
    if (prisMin) { prisMin.value = prisLav; prisMaks.value = prisHoy; }
    bruk();
  }

  /* Mobil: filterskuff */
  var sistFokus = null;
  function apne() {
    sistFokus = document.activeElement;
    panel.classList.add('er-apen');
    if (skygge) skygge.hidden = false;
    document.body.classList.add('kt-filter-apen');
    if (apneKnapp) apneKnapp.setAttribute('aria-expanded', 'true');
    var lukk = panel.querySelector('.kt-filter-lukk');
    if (lukk) lukk.focus();
  }
  function lukk() {
    if (!panel.classList.contains('er-apen')) return;
    panel.classList.remove('er-apen');
    if (skygge) skygge.hidden = true;
    document.body.classList.remove('kt-filter-apen');
    if (apneKnapp) apneKnapp.setAttribute('aria-expanded', 'false');
    if (sistFokus && sistFokus.focus) sistFokus.focus();
  }

  if (apneKnapp) apneKnapp.addEventListener('click', apne);
  rot.querySelectorAll('[data-filter-lukk]').forEach(function (b) { b.addEventListener('click', lukk); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lukk(); });
  rot.querySelectorAll('[data-filter-nullstill]').forEach(function (b) { b.addEventListener('click', nullstill); });

  skjema.addEventListener('change', bruk);
  if (prisMin) {
    [prisMin, prisMaks].forEach(function (inp) {
      inp.addEventListener('input', function () {
        if (Number(prisMin.value) > Number(prisMaks.value)) {
          if (inp === prisMin) prisMin.value = prisMaks.value; else prisMaks.value = prisMin.value;
        }
        bruk();
      });
    });
  }
  if (sortering) sortering.addEventListener('change', function () { sorter(); bruk(); });

  rot.querySelectorAll('[data-merke-kort]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var m = a.getAttribute('data-merke-kort');
      skjema.querySelectorAll('[name="merke"]').forEach(function (i) { i.checked = m !== '' && i.value === m; });
      bruk();
    });
  });

  lesAdresse();
  sorter();
  bruk();

  /* Vare-rad på forsiden: piler som blar én skjermbredde, deaktiveres i endene */
  document.querySelectorAll('[data-rad]').forEach(function (rad) {
    var seksjon = rad.closest('section');
    if (!seksjon) return;
    var forrige = seksjon.querySelector('[data-rad-forrige]');
    var neste = seksjon.querySelector('[data-rad-neste]');
    var oppdater = function () {
      if (forrige) forrige.disabled = rad.scrollLeft <= 4;
      if (neste) neste.disabled = rad.scrollLeft + rad.clientWidth >= rad.scrollWidth - 4;
    };
    var bla = function (retning) { rad.scrollBy({ left: retning * rad.clientWidth * 0.9, behavior: 'smooth' }); };
    if (forrige) forrige.addEventListener('click', function () { bla(-1); });
    if (neste) neste.addEventListener('click', function () { bla(1); });
    rad.addEventListener('scroll', oppdater, { passive: true });
    window.addEventListener('resize', oppdater);
    oppdater();
  });
})();
